import React from "react";
import { useTranslation } from "react-i18next";

import { Container, Anchor, Text } from "@mantine/core";

import { ContentHighlightCard } from "../components/ContentHighlightCard/index";
import { LanguageSelectStandalone } from "@components/LanguageSelect/index";

import { useColors } from "@utils/useColors";
import { useFooterUrls } from "@pages/start/layout/layout";

export const AccountActiveError = React.memo(() => {
  const { t } = useTranslation();
  const { contactUrl } = useFooterUrls();

  const { mango50, tufts10 } = useColors();

  return (
    <ContentHighlightCard>
      <Container bg={mango50} py="md" style={{ borderRadius: 10 }}>
        <Text>{t("startPage.errorUI.box1part1")}</Text>
        <Text mt={12}>{t("startPage.errorUI.box1part2")}</Text>
      </Container>

      <Container bg={tufts10} py="md" mt="lg" style={{ borderRadius: 10 }}>
        <Text fw="bold">{t("startPage.errorUI.box2part1")}</Text>
        <Text mt={12}>
          {t("startPage.errorUI.box2part2") + " "}
          <Anchor
            href={contactUrl}
            target="_blank"
            rel="noopener noreferrer"
            fw="bold"
          >
            {t("startPage.errorUI.familyCareTeam")}
          </Anchor>
        </Text>
      </Container>

      <Container mt="lg">
        <LanguageSelectStandalone />
      </Container>
    </ContentHighlightCard>
  );
});

AccountActiveError.displayName = "AccountActiveError";
